<template>
  <div class="avatar-area">
    <el-dropdown class="avatar-container" trigger="click" @command="handleCommand">
      <div class="avatar-wrapper">
        <el-avatar :size="adaptationVars.avatarSize" class="user-avatar">
          <img :src="avatarImg" />
        </el-avatar>
        <div class="user-name">
          <span>{{ userInfo.username }}</span>
        </div>
        <i :class="['iconfont', 'icon-dropdown', 'avatar-dropdown-icon']" />
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
        <el-dropdown-item command="reset">
          <span>修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item command="edit">
          <span>编辑用户</span>
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          <span>退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <reset-pwd ref="resetPwd"></reset-pwd>
    <edit-user ref="editUser"></edit-user>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import resetPwd from './Password'
import editUser from './editUser'
import avatarImg from '@/assets/images/avatar.png'
import adaptation from '@/mixins/adaptation'

export default {
  name: 'UserAvatar',
  components: {
    resetPwd,
    editUser
  },
  mixins: [adaptation],
  adaptationVarsDefine: {
    avatarSize: 32
  },
  data() {
    return {
      avatarImg,
      adaptationVars: {
        avatarSize: 32
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: index => {
        return (
          index.app.userInfo || {
            username: ''
          }
        )
      }
    }),
    userName: function() {
      if (this.userInfo) {
        return this.userInfo.nickname || this.userInfo.username
      } else {
        return 'userName'
      }
    }
  },
  methods: {
    ...mapActions(['removeUserInfo']),

    handleCommand(command) {
      if (command === 'logout') {
        this.$apis.app.logout().then(res => {
          this.$router.push({
            path: '/login',
            query: {
              type: 'logout'
            }
          })
          window.localStorage.clear()
          history.pushState(null, null, document.URL)
          window.addEventListener(
            'popstate',
            function(e) {
              history.pushState(null, null, document.URL)
            },
            false
          )
        })
      } else if (command === 'reset') {
        this.$refs.resetPwd.handleOpen(this.userInfo)
      } else {
        this.$refs.editUser.handleOpen(this.userInfo)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.avatar-area {
  height: var(--navbar-avatar-area-height);

  .avatar-container {
    height: var(--navbar-avatar-area-height);
    padding: auto;

    .avatar-wrapper {
      height: var(--navbar-avatar-area-height);
      display: flex;
      justify-content: center;
      align-items: center;

      .user-name {
        cursor: pointer;
        color: var(--navbar-avatar-username);
        font-size: var(--navbar-avatar-name-fontsize);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: var(--navbar-avatar-name-margin);
      }

      .avatar-dropdown-icon {
        color: var(--navbar-avatar-dropdown);
        font-size: var(--navbar-avatar-dropdown-fontsize);
      }
    }
  }
}
</style>
